// extracted by mini-css-extract-plugin
export default {"flag":"TabulatorNav_flag__iyuOB","name":"TabulatorNav_name__IfSCL","container":"TabulatorNav_container__6d0i7"};